// xs = array []
// childSelector - function e.g: x => x.children
export function flatten(array, childSelector, path = 'children') {
    return array.reduce((acc, x, index) => {
        try {
            acc = acc.concat({...x, _path: path + '.' + index});
            let children = childSelector(x);
            if (children) {
                acc = acc.concat(flatten(children, childSelector, path + '.' + index + '.' + 'children'));
            }
            return acc
        } catch (e) {
            console.log(e)
        }
    }, [])
}